import React from 'react';

// Style sheets
import Style from './Display.module.scss';

export function Display(props){
    const calculation = props.calculation;
    const total = props.total;
    const currentPressed = props.currentPressed;
    const darkMode = props.darkMode;

    return(
        <div className={darkMode === true ? `${Style.Display} ${Style.White}` : `${Style.Display} ${Style.Black}`}>
            <h6 className={
                String(calculation).length >= 20 
                    ? `${Style.Result} ${Style.TextSmallest}` : Style.Result}>
                {calculation}
            </h6>
            <h1 className={
                String(total).length >= 14 || currentPressed.length >= 14 
                    ? `${Style.Total} ${Style.TextSmaller}` :  String(total).length >= 9 || currentPressed.length >= 9 
                        ? `${Style.Total} ${Style.TextSmall}` : Style.Total
                }>
                    {total === null ? currentPressed : total}
            </h1>
        </div>
    );
}